import type { ToolRenderKind } from "@/types";
import { MARKDOWN_RESOURCE_LINK_SCHEMES } from "@/utils/markdownResource";
import { formatMarkdownResourceLinksAsText } from "@/utils/markdownResource";

export const xGroupMarkdownResourceLinkSchemes = MARKDOWN_RESOURCE_LINK_SCHEMES;

export const formatXGroupMarkdownResourceLinksAsText = (
  text: string,
  options?: { stripTrigger?: boolean },
) =>
  formatMarkdownResourceLinksAsText(text, {
    ...options,
    schemes: xGroupMarkdownResourceLinkSchemes,
  });

/** 众安信科预设的工具类型映射，集中处理当前后端约定的 tool name。 */
export const xGroupToolKindResolver = ({
  name,
}: {
  name?: string;
}): ToolRenderKind => {
  if (name === "adk_request_confirmation") return "approval";
  if (name === "transferToAgent") return "handoff";
  return "default";
};
